import React from "react";
import SubscribersList from "../../../components/SubscribersList";
import { useViewSegmentContent } from "./ViewSegmentContent.hooks";

function ViewSegmentContent() {
  const { segmentId, mdUp } = useViewSegmentContent();

  return (
    <SubscribersList
      pageName="segments"
      segmentId={segmentId}
      enableEdit
      showChip={true}
      bgcolor="white"
      borderRadius={mdUp ? "6px" : "0px"}
      hideSort
      hideDelete
    />
  );
}

export default ViewSegmentContent;
